module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0014.16f9a9d4.jpg";